<template>
  <!-- 模板方案 -->
  <div class="banner-config-wrapper">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
    </div>
    <el-main>
      <div class="record-wrapper">
        <div class="record-content">
          <div class="title-box">
            <h1 class="top_title"><span></span>用户集合</h1>
          </div>

          <div class="record-content-one">
            <el-form label-width="150px" size="mini" label-position="right" class="edit">
              <el-row :gutter="40">
                <el-col :xl="12" :lg="12" :span="12">
                  <el-form-item label="集合分类：" prop="name">
                    <div class="label-item">
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :span="12">
                  <el-form-item label="集合名称：" prop="name">
                    <div class="label-item">
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :span="12">
                  <el-form-item label="创建时间：" prop="name">
                    <div class="label-item">
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :span="12">
                  <el-form-item label="创建人：" prop="name">
                    <div class="label-item">
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="record-content">
          <div class="title-box">
            <h1 class="top_title"><span></span>运营消息</h1>
          </div>

          <div class="record-content-one">
            <el-form label-width="150px" size="mini" label-position="right" class="edit">
              <el-row :gutter="40">
                <el-col :xl="12" :lg="12" :span="12">
                  <el-form-item label="消息标题：" prop="name">
                    <div class="label-item">
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :span="12">
                  <el-form-item label="消息内容：" prop="name">
                    <div class="label-item">
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :span="12">
                  <el-form-item label="推送渠道：" prop="name">
                    <div class="label-item">
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :xl="12" :lg="12" :span="12">
                  <el-form-item label="发送时间：" prop="name">
                    <div class="label-item">
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="record-content">
          <div class="title-box">
            <h1 class="top_title"><span></span>目标用户</h1>
            <div class="title-box-right">
              <div class="user-box-item"><span class="user-box-item-title">可发送：</span><span
                  class="user-box-item-text">213</span></div>
              <div class="user-box-item"><span class="user-box-item-title">发送：</span><span
                  class="user-box-item-text">200</span></div>
              <div class="user-box-item"><span class="user-box-item-title">送达：</span><span
                  class="user-box-item-text">26</span></div>
              <div class="user-box-item"><span class="user-box-item-title">展示：</span><span
                  class="user-box-item-text">26</span></div>
              <div class="user-box-item"><span class="user-box-item-title">点击：</span><span
                  class="user-box-item-text">26</span></div>
            </div>
          </div>

          <div class="record-content-one">
            <div class="dialog-main-content">
              <div class="search-box">
                <!-- <div class="search-box-left"> -->
                <el-input placeholder="请输入姓名或手机号" v-model.trim="listQueryShop.goodsName" maxlength="20"
                  size="small"></el-input>
                <el-select v-model="listQueryShop.send" size="small" value-key="send"  placeholder="请选择发送状态"
                  @change="sendChange">
                  <el-option v-for="item in sendList" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
                <!-- </div> -->
                <div class="search-box-right">
                  <el-button @click="resetClickShop" size="small">重置</el-button>
                  <el-button type="primary" @click="searchClickShop" size="small">搜索</el-button>
                </div>

              </div>
              <div>
                <div class="main-content-list" style="max-height:430px;overflow:auto;">
                  <el-table :data="tableDataShop" style="width: 100%;" :header-cell-style="{
                background: '#FAFAFA',
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '14px'
              }">
                    <el-table-column prop="index" label="序号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="goodsName" label="姓名" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="goodsDesc" label="手机号" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="goodsDesc" label="发送状态" align="center">
                      <template slot-scope="scope">
                        <div class="send-box">
                          <span class="send-icon-one">待发送</span>
                          <!-- <span class="send-icon-two">已发送</span>
                          <span class="send-icon-three">发送中</span>
                          <span class="send-icon-four">发送失败</span>
                          <span class="send-icon-four">已展示</span>
                          <span class="send-icon-four">已点击</span> -->
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                      <template slot-scope="scope">
                        <el-button @click.native.prevent="assessmentSendShop(scope.$index, scope.row)" type="text"
                          size="small">
                          详情
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 分页 -->
                <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
                  <el-pagination background :current-page="listQueryShop.current" :page-sizes="[10, 20, 30, 50]"
                    :page-size="listQueryShop.size" layout="total, sizes, prev, pager, next, jumper" :total="totalShop"
                    @size-change="handleSizeChangeShop" @current-change="handleCurrentChangeShop" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>

  </div>
</template>
  
  <script>
import {
  getStrategicDiseaseAndWechat,
  setTop,
  setStatus,
  deleteBanner,
  wechatApp,
  wechatBanner,
  wechatBannerEdit
} from "../api/medicalInquirie";

import {
  pageList,
  pagelandDelete,
  publish,
  termListData,
  getLandingpageGoodsStatusByLandingPageId
} from "../api/landPage";

export default {
  data() {
    return {
      breadList: [{ name: "运营管理" }, { name: "落地页配置" }],
      listQueryShop: {
        //商品搜索条件
        //弹窗
        current: 1,
        size: 10,
        goodsName: null
      },
      tableDataShop: [1], //添加集合数组
      totalShop: 0,
      sendList: [
        {
          name: "待发送",
          value: 0
        },
        {
          name: "已发送",
          value: 1
        },
        {
          name: "发送中",
          value: 2
        },
        {
          name: "发送失败",
          value: 3
        },
        {
          name: "已展示",
          value: 4
        },
        {
          name: "已点击",
          value: 5
        }
      ]
    };
  },
  created() {},
  methods: {
    resetClickShop() {
      //弹窗集合服务重置
      this.listQueryShop.size = 10;
      this.listQueryShop.current = 1;
      this.listQueryShop.goodsName = null;
      this.shopPageRequest();
    },
    searchClickShop() {
      //弹窗集合服务搜索
      this.listQueryShop.size = 10;
      this.listQueryShop.current = 1;
      this.shopPageRequest();
    },
    assessmentSendShop(index, row) {
      this.tableDataShop[index].flag = false;
      //选择集合
      this.tableDataShop[index].flag = false;
      this.shopNameList.push(objService);
      this.phoneList[this.index].goods = this.shopNameList;
    },
    handleSizeChangeShop(val) {
      //添加集合分页
      this.listQueryShop.size = val;
      this.listQueryShop.current = 1;
      this.shopPageRequest();
    },
    handleCurrentChangeShop(val) {
      //添加集合分页
      this.listQueryShop.current = val;
      this.shopPageRequest();
    },
    sendChange() {}
  }
};
</script>
  
<style lang="less" scoped>
@import "./operationalMessageRecord.less";
</style>
  